import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { Col, Row, Spinner } from 'react-bootstrap';
import { useAbility } from '@casl/react';
import { indexCourseRequest } from '../../../requests/courses';
import HRDashboardStyled from '../../HRDashboardStyled';
import { AbilityContext } from '../../../config/abilityContext';

const TrainingCard = () => {
  const ability = useAbility(AbilityContext);
  const [showSpinner, setShowSpinner] = useState(0);
  const [amount, setAmount] = useState(0);
  const dispatch = useDispatch();
  const history = useHistory();
  const canIndex = ability.can('index', 'Course');

  const handleCardClick = () => {
    history.push('/profile/courses');
  };

  const handleRequest = () => {
    if (!canIndex) return;
    setShowSpinner(1);
    const request = async () =>
      indexCourseRequest({
        dispatch,
        params: {
          is_public: 'published'
        },
        successCallback: response => {
          setShowSpinner(0);
          setAmount(response.data.metadata.amount);
        },
        callback: () => setShowSpinner(0)
      });
    request();
  };
  useEffect(handleRequest, []);

  return (
    <>
      {showSpinner ? (
        <Row className="align-items-center">
          <Col className="mt-5">
            <div className="containerSpinnerLoadDash mb-5">
              <Spinner animation="border" variant="primary" />
            </div>
          </Col>
        </Row>
      ) : (
        <HRDashboardStyled
          title={amount}
          label="Capacitaciones"
          labelColor="#827f7f"
          TopHeaderColor="#fff"
          GeneralColor="#ECBA44"
          subtitle="Cursos"
          TypeCard="OnlyInformation"
          onRequest={false}
          Downloadable={false}
          labelFontSize="12px"
          ViewMore={canIndex}
          onClick={handleCardClick}
        />
      )}
    </>
  );
};

export default TrainingCard;
